export default function config() {
  const tableColumns = [
    { key: 'index', label: '#', thStyle: { width: '80px' } },
    { key: 'name_uz', label: 'Dissertation topic (uz)', sortable: true },
    { key: 'name_ru', label: 'Dissertation topic (ru)', sortable: true },
    { key: 'name_en', label: 'Dissertation topic (en)', sortable: true },
    { key: 'cipher', label: 'Topic number', sortable: true },
    { key: 'apply_doc', label: 'Student', sortable: true },
    { key: 'protocol', label: 'Protocol', sortable: true },
  ]

  return {
    tableColumns,
  }
}
